// Shared cache for user's fixed monthly commitments (rent, salaries, subscriptions).
import { useEffect, useState } from "react";
import api from "@/lib/api";

let cache = { items: [], total_monthly: 0, ts: 0 };
const listeners = new Set();

export async function refetchCommitments() {
  try {
    const r = await api.get("/commitments");
    cache = { ...r.data, ts: Date.now() };
    listeners.forEach((cb) => cb(cache));
  } catch { /* ignore */ }
}

export function useCommitments() {
  const [state, setState] = useState(cache);
  useEffect(() => {
    listeners.add(setState);
    if (Date.now() - cache.ts > 30_000) refetchCommitments();
    return () => listeners.delete(setState);
  }, []);
  return state;
}

if (typeof window !== "undefined") window.addEventListener("malat:data-changed", refetchCommitments);
